export default __webpack_public_path__ + "static/ServiceEventMakeupIcon-c72ec230c1f36883bdec0c3a298086aa.svg";